<ng-container *ngIf="!isLoading">
  <div class="u-container u-padding-32-0">
    <h6 i18n="@@global.settings" class="color-grey-300 u-marginBottom-16">
      Settings
    </h6>
    <div class="u-marginBottom-16 mat-elevation-z1 bg-color-white">
      <app-settings-personal-email-change
        *ngIf="user$ | async as user"
        class="u-display-block u-padding-24 u-borderBottom-grey50"
        [account]="user"
        [isEmailChangeEnabled]="tenant.email_change_allowed"
      ></app-settings-personal-email-change>
      <div *ngFor="let settings of settingsView">
        <ng-container *ngIf="'expansion' === settings.type">
          <app-form-template-expansion-panels
            [panels]="settings.panels"
            class="u-display-block u-marginBottom-24"
          >
          </app-form-template-expansion-panels>
        </ng-container>
        <ng-container *ngIf="'card' === settings.type">
          <app-form-template-card-panel
            *ngFor="let panel of settings.panels"
            [actions]="panel.actions"
            [description]="panel.description"
            [disableActionBar]="panel.disableActionBar"
            [disableForms]="panel.disableForms"
            [disableFormsText]="panel.disableFormsText"
            [forms]="panel.forms"
            [headerAction]="panel.headerAction"
            [title]="panel.title"
            (formChanged)="
              panel.formsCallback ? panel.formsCallback($event) : {}
            "
            [validators]="panel.validators"
            class="u-display-block u-borderBottom-standard"
          >
          </app-form-template-card-panel>
        </ng-container>
        <ng-container
          *ngIf="'toggle' === settings.type"
          class="u-marginBottom-24"
        >
          <app-form-template-toggle-panel
            *ngFor="let panel of settings.panels"
            [description]="panel.description"
            [forms]="panel.forms"
            [title]="panel.title"
            (formChange)="
              panel.formsCallback ? panel.formsCallback($event) : {}
            "
            class="u-display-block"
          >
          </app-form-template-toggle-panel>
        </ng-container>
      </div>
    </div>
    <div
      class="mat-elevation-z1 bg-color-white u-borderRadius--4px u-padding-24"
    >
      <div
        class="u-marginBottom-16"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
      >
        <mat-icon class="material-symbols-outlined md-18">experiment</mat-icon>
        <p>
          <b i18n="@@settingsPersonal.contributeToProductEnhancements"
            >Contribute to product enhancements</b
          >
        </p>
      </div>
      <app-settings-screen-recording
        [user]="user$ | async"
        class="u-display-block"
      ></app-settings-screen-recording>
    </div>
  </div>
</ng-container>
<div *ngIf="isLoading" class="u-marginTop-40">
  <div fxLayout="row" fxLayoutAlign="center center">
    <app-progress-spinner [size]="'large'"></app-progress-spinner>
  </div>
</div>
